var indentStyle = {"indentZero":"_-8QuK","indentOne":"BhJyD","indentTwo":"lMQpZ","indentThree":"Z8d9Y","indentFour":"pumB1","indentFive":"qtxIi","indentSix":"_2bQwJ"};

export { indentStyle as i };
//# sourceMappingURL=indentation-fcdd3da8.js.map
